import { useEffect, useRef } from "react";
import { recordPerf } from "./report";
import type { PerfMetricName } from "./types";

/**
 * Records how long a screen took to become usable. Mount it on a page with the
 * page's loading flag; the metric is recorded once, the first time the page
 * finishes loading. Never blocks rendering.
 */
export function usePageLoadMetric(metric: PerfMetricName, isLoading: boolean): void {
  const start = useRef<number>(Date.now());
  const done = useRef(false);

  useEffect(() => {
    if (done.current || isLoading) return;
    done.current = true;
    recordPerf(metric, Date.now() - start.current);
  }, [metric, isLoading]);
}
